import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import ConversationItemType from 'models/conversation_item_type';
import Communicator from 'models/communicator';
import CreditCardRequestButton from 'components/composer/chat/credit_card_request_button';
import InteractionType from 'models/composition/interaction_type';
import connect from 'components/lib/connect';
import { AccountType } from 'models/account';
import { AgentParticipantStatus } from 'models/routing_queue_item';
import { AttachmentStyles, EmojiStyles } from 'components/composer/shared/editor_styles';
import { getActiveChatSessionByCustomer } from 'actions/concurrent_messaging/session_finder';
import { getLatestManualItem } from 'scripts/application/lib/conversation_history_helpers';

const ComposerButtonsContainer = styled.div`
  display: flex;
`;

export function ComposerButtons({
  agentIsExistingChatParticipant,
  isVGSEnabled,
  hasActiveSecureDataRequests,
  paymentIsEnabledForPlatform,
  editorRef,
}) {
  const showCreditCardRequestButton = isVGSEnabled && agentIsExistingChatParticipant && paymentIsEnabledForPlatform;
  return (
    <ComposerButtonsContainer>
      <EmojiStyles editorRef={editorRef} />
      {showCreditCardRequestButton && !hasActiveSecureDataRequests ? (
        <CreditCardRequestButton data-aid={'credit-card-request-button'} />
      ) : null}
      <AttachmentStyles data-aid={'attachment-styles'} />
    </ComposerButtonsContainer>
  );
}

ComposerButtons.propTypes = {
  agentIsExistingChatParticipant: PropTypes.bool.isRequired,
  hasActiveSecureDataRequests: PropTypes.bool.isRequired,
  isVGSEnabled: PropTypes.bool.isRequired,
  paymentIsEnabledForPlatform: PropTypes.bool.isRequired,
  editorRef: PropTypes.shape({ current: PropTypes.any }),
};

function mapStateToProps({ getProvider, isFeatureEnabled }) {
  const accounts = getProvider('accounts');
  const activeSecureDataRequests = getProvider('activeSecureDataRequests');
  const activeSessionsProvider = getProvider('activeSessions');
  const channelConfiguration = getProvider('channelConfiguration').get();
  const conversationHistory = getProvider('conversationHistory');
  const currentAgent = getProvider('currentAgent').get();
  const customer = getProvider('profile').get();

  const customerId = customer.id;
  const isVGSEnabled = !!accounts.findBy({ type: AccountType.VGS });

  let hasActiveSecureDataRequests = _hasActiveSecureDataRequests(activeSecureDataRequests);
  const activeSession = getActiveChatSessionByCustomer(activeSessionsProvider, customerId);
  let agentIsExistingChatParticipant = _isAgentExistingChatParticipant(activeSession, currentAgent.id);
  let paymentIsEnabledForPlatform = false;

  if (activeSession) {
    const activeChatSession = _getActiveChatSession(activeSession);
    const item = getLatestManualItem({
      conversationHistory,
      conversationId: activeSession.queueItem.conversationId,
      filter: ci => {
        const initiatorType = _.get(ci, 'initiator.type');
        return (
          ci.content.type === ConversationItemType.CHAT_MESSAGE &&
          ci.content.sessionId === activeChatSession.id &&
          initiatorType === Communicator.CUSTOMER
        );
      },
    });

    if (activeChatSession && item) {
      paymentIsEnabledForPlatform = _isPaymentEnabledForPlatform(
        channelConfiguration.endpoints,
        activeChatSession.endpointAddress,
        item.content.platform
      );
    }
  }
  return {
    agentIsExistingChatParticipant,
    hasActiveSecureDataRequests,
    isVGSEnabled,
    paymentIsEnabledForPlatform,
  };
}

function _hasActiveSecureDataRequests(activeSecureDataRequests) {
  return activeSecureDataRequests && activeSecureDataRequests.findAll().length !== 0;
}

function _isAgentExistingChatParticipant(activeSession, currentAgentId) {
  return (
    activeSession && activeSession.queueItem.getAgentParticipantStatus(currentAgentId) === AgentParticipantStatus.ACTIVE
  );
}

function _getActiveChatSession(activeSession) {
  return activeSession.queueItem.getSessionByType(InteractionType.CHAT) || {};
}

function _isPaymentEnabledForPlatform(endpoints, endpointAddress, platform) {
  const endpoint = _.find(endpoints, ep => ep.address === endpointAddress) || {};
  const paymentRequestEnabledFor = _.get(endpoint, 'configuration.paymentRequestEnabledFor') || [];
  return _.includes(paymentRequestEnabledFor, platform);
}

export default connect(mapStateToProps)(ComposerButtons);



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/composer/chat/composer_buttons.jsx